/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ActionComponentConfig,
  ActionComponentConfig$inboundSchema,
  ActionComponentConfig$Outbound,
  ActionComponentConfig$outboundSchema,
} from "./actioncomponentconfig.js";
import {
  ConditionExpression,
  ConditionExpression$inboundSchema,
  ConditionExpression$Outbound,
  ConditionExpression$outboundSchema,
} from "./conditionexpression.js";

/**
 * The config of the action component state
 */
export type ActionComponentStateConfig = {
  /**
   * The config of the action component. Must contain one of button_config or dropdown_config.
   */
  actionComponentConfig?: ActionComponentConfig | undefined;
  /**
   * Defines a condition expression. Can be a single condition, a group of conditions, or nested groups. Exactly one of 'condition', 'condition_group', or 'nested_expression' must be specified.
   */
  conditionExpression?: ConditionExpression | undefined;
  /**
   * Whether this state is the default state. If this is true, conditions are not required. For readability, these states should be at the end of the array.
   */
  isDefault?: boolean | undefined;
  /**
   * The priority of the state. There is no constraint on overlapping conditions, so this field allows user to set priority.
   */
  priority?: number | undefined;
  /**
   * The name of the state
   */
  stateName: string;
};

/** @internal */
export const ActionComponentStateConfig$inboundSchema: z.ZodType<
  ActionComponentStateConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  action_component_config: types.optional(ActionComponentConfig$inboundSchema),
  condition_expression: types.optional(ConditionExpression$inboundSchema),
  is_default: types.boolean().default(false),
  priority: types.number().default(0),
  state_name: types.string(),
}).transform((v) => {
  return remap$(v, {
    "action_component_config": "actionComponentConfig",
    "condition_expression": "conditionExpression",
    "is_default": "isDefault",
    "state_name": "stateName",
  });
});
/** @internal */
export type ActionComponentStateConfig$Outbound = {
  action_component_config?: ActionComponentConfig$Outbound | undefined;
  condition_expression?: ConditionExpression$Outbound | undefined;
  is_default: boolean;
  priority: number;
  state_name: string;
};

/** @internal */
export const ActionComponentStateConfig$outboundSchema: z.ZodType<
  ActionComponentStateConfig$Outbound,
  z.ZodTypeDef,
  ActionComponentStateConfig
> = z.object({
  actionComponentConfig: ActionComponentConfig$outboundSchema.optional(),
  conditionExpression: ConditionExpression$outboundSchema.optional(),
  isDefault: z.boolean().default(false),
  priority: z.number().int().default(0),
  stateName: z.string(),
}).transform((v) => {
  return remap$(v, {
    actionComponentConfig: "action_component_config",
    conditionExpression: "condition_expression",
    isDefault: "is_default",
    stateName: "state_name",
  });
});

export function actionComponentStateConfigToJSON(
  actionComponentStateConfig: ActionComponentStateConfig,
): string {
  return JSON.stringify(
    ActionComponentStateConfig$outboundSchema.parse(actionComponentStateConfig),
  );
}
export function actionComponentStateConfigFromJSON(
  jsonString: string,
): SafeParseResult<ActionComponentStateConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ActionComponentStateConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ActionComponentStateConfig' from JSON`,
  );
}
